<template>
    <div class="interface-config-form">
        <div v-if="edit" class="top-tips">
            考虑到用户咨询体验，请确保接口在3秒内响应
        </div>
        <div
            v-spinner="loading"
            class="content-config"
        >
            <v-spinner size="large" />
            <v-form
                v-if="edit"
                ref="configForm"
                layout="vertical"
                kind="desc"
                @submit="formSubmit"
            >
                <v-form-item
                    :rules="rules.clientId"
                    required="OAuth2.0 client_id必填"
                    name="clientId"
                    label="OAuth2.0 client_id"
                >
                    <v-textarea
                        v-model="config.client_id"
                        :limit="128"
                        placeholder="请输入"
                        style="width:550px;"
                    />
                </v-form-item>
                <v-form-item
                    :rules="rules.clientSecret"
                    required="OAuth2.0 client_secret必填"
                    name="clientSecret"
                    label="OAuth2.0 client_secret"
                >
                    <v-textarea
                        v-model="config.client_secret"
                        :limit="512"
                        placeholder="请输入"
                        style="width:550px;"
                    />
                </v-form-item>
                <v-form-item
                    v-for="(item, index) in config.apis"
                    :key="index"
                    :rules="rules.profile"
                    :label="item.label"
                    :name="item.business"
                    :required="item.required ? `${item.label}必填` : ''"
                >
                    <a
                        v-show="item.api_guide_link"
                        :href="item.api_guide_link"
                        class="content-config-link"
                        target="_blank"
                    >{{ item.api_guide_lable }}</a>
                    <v-textarea
                        v-model="item.url"
                        :limit="1024"
                        kind="default"
                        placeholder="请输入以https开头的地址"
                        style="width:550px;"
                    />
                </v-form-item>
                <v-form-item>
                    <div class="btn_submit">
                        <v-footer-actionbar
                            size="large"
                        >
                            <div slot="footer-actionbar-button">
                                <v-button
                                    :loading="loading"
                                    type="submit"
                                    kind="primary"
                                    size="large"
                                    style="margin-right: 10px;"
                                    :disabled="isDisabled"
                                >
                                    保存
                                </v-button>
                                <v-button
                                    size="large"
                                    @click="cancel"
                                >
                                    取消
                                </v-button>
                            </div>
                        </v-footer-actionbar>
                    </div>
                </v-form-item>
            </v-form>
            <v-descriptions
                v-else
                class="interface-config-descriptions"
                layout="vertical"
            >
                <v-description-item
                    :value="config.client_id || '-'"
                    layout="vertical"
                    text="OAuth2.0 client_id"
                />
                <v-description-item
                    :value="config.client_secret || '-'"
                    layout="vertical"
                    text="OAuth2.0 client_secret"
                />
                <v-description-item
                    v-for="(item, index) in config.apis"
                    :key="index"
                    :col="1"
                    :value="item.url || '-'"
                    :text="item.label"
                    layout="vertical"
                />
            </v-descriptions>
            <v-button
                v-if="!edit"
                status="primary"
                @click="changeStatus"
            >
                编辑
            </v-button>
        </div>
        <v-dialog
            v-model="confirmDialogVisible"
            kind="confirm"
            title="是否要保存当前修改内容?"
            confirm-text="保存"
            class="auth-dialog"
            @confirm="handleDialogConfirm"
            @cancel="handleDialogCancel"
            @close="handleDialogClose"
        />
    </div>
</template>

<script>
import MixinConfig from '../../MixinConfig';

export default {
    name: 'ConfigForm',
    mixins: [MixinConfig],
    data() {
        return {
            config: {
                client_id: '',
                client_secret: '',
                apis: [],
            },

            saveUrl: '/v1/basic/account/integration/saveSetting',
            getUrl: '/v1/basic/account/integration/setting',
        };
    },

    computed: {
        saveParams() {
            return {
                setting: {
                    client_id: this.config.client_id,
                    client_secret: this.config.client_secret,
                    apis: this.config.apis.map(item => ({
                        business: item.business,
                        url: item.url,
                        method: item.method,
                        params_mapping: item.params_mapping,
                    })),
                },
            };
        },
    },

    methods: {
        async getInitData() {
            const data = await this.getBeforeConfig(this.getUrl) || {};
            const content = data.setting || {};
            this.config = {
                client_id: content.client_id || '',
                client_secret: content.client_secret || '',
                apis: content.apis || [],
            };
            this.oldConfig = JSON.parse(JSON.stringify(this.config));
        },
    },
};
</script>
<style lang="less" scoped>
.interface-config-form {
    .top-tips {
        margin-bottom: 16px;
    }
}
.btn_submit {
    position: fixed;
    width: -webkit-fill-available;
    bottom: 0;
    background-color: #fff;
    opacity: 1;
    z-index: 17;
}

.interface-config-descriptions {
    overflow: hidden;
}

.content-config-link {
    position: absolute;
    top: -28px;
    left: 200px;
    cursor: pointer;
}
</style>

